import { NON_REDIRECTABLE_AUTH_ERROR_PATHS } from "@/axiosConfig";
import router from "@/router";

export const getPathView = () => {
  const currentRoute = router.app._route
  const regexIsAvailable = Array.isArray(currentRoute.matched) && currentRoute.matched.length > 1;
  if (regexIsAvailable) {
    const { path } = currentRoute.matched[currentRoute.matched.length - 1]
    const resolvedPath = path.replace(/\/:\w+\??/g, "").replace(/\/$/, "");
    return resolvedPath
  }

  return currentRoute.fullPath
}

export const isExcludedPath = () => {
  try {
    const currentPath = location.pathname;
    return NON_REDIRECTABLE_AUTH_ERROR_PATHS.some(path => {
      if (path.includes('*')) {
        const pathPattern = path.replace('*', '.*');
        const regex = new RegExp(`^${pathPattern}$`);
        return regex.test(currentPath);
      }
      return currentPath.endsWith(path) || currentPath === path;
    });
  } catch (e) {
    console.error('Error al verificar si la ruta está excluida:', e);
    return false;
  }
};


function cleanRoute(route) {
  return route.replace(/[\?#].*$/, '');
}

export function isRoutesDifferent(route1, route2) {
  return cleanRoute(route1) !== cleanRoute(route2);
}
